<script lang="ts" module>
	import type { HTMLAttributes } from 'svelte/elements';

	export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
		wrapperClass?: string;
		marginMode?: 'both' | 'mx' | 'my';
	}
</script>

<script lang="ts">
	import ContainerMargin from './containerMargin.svelte';
	import ContainerMx from './containerMx.svelte';

	let {
		wrapperClass = '',
		marginMode = 'mx',
		class: className,
		children,
		...other
	}: ContainerProps = $props();
</script>

<ContainerMargin class={wrapperClass} mode={marginMode} {...other}>
	<ContainerMx class={className}>
		{@render children?.()}
	</ContainerMx>
</ContainerMargin>
